var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lib-section-desc',{attrs:{"content":_vm.content,"title":"O systemie c-KOB"}})
}
var staticRenderFns = []

export { render, staticRenderFns }